var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        ", "\n        stroke: white;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n        ", "\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.34,44.34h15.16c1.66,0,3-1.34,3-3v-7.69c0-1.66-1.34-3-3-3h-15.16c-1.66,0-3-1.34-3-3v-15.16c0-1.66-1.34-3-3-3h-5.69c-2.76,0-5,2.24-5,5v13.16c0,1.66-1.34,3-3,3h-15.16c-1.66,0-3,1.34-3,3v7.69c0,1.66,1.34,3,3,3h15.16c1.66,0,3,1.34,3,3v15.16c0,1.66,1.34,3,3,3h7.69c1.66,0,3-1.34,3-3v-15.16c0-1.66,1.34-3,3-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlus);
export default __webpack_public_path__ + "static/media/__Add - Plus.751f04f2b5c1d5974ae77178f81e2fe4.svg";
export { ForwardRef as ReactComponent };